
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-text)"}},[_c('path',{attrs:{"d":"M3 0v4.5h3V3h4.5v18h-3v3h9v-3h-3V3H18v1.5h3V0H3z","fill":"#838383"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-text"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    